import { concatWithComma } from "./concatWithComma";

export const formatCertificatesListLink = (inputList) => {
  let result = "nombres_alumnos_ec=";

  inputList.forEach((element, index) => {
    element.certificatesList.forEach((certificate, certificateListIndex) => {
      if (certificateListIndex === element.certificatesList.length - 1) {
        if (index !== inputList.length - 1) {
          result += `${certificate.trimEnd()};`;
        } else {
          result += `${certificate.trimEnd()}`;
        }
      } else {
        result += certificate.trimEnd() + ",";
      }
    });
    result.slice(0, -1) + "";
  });
  return result;
};

export const formatShipmentDataLink = (inputList) => {
  let nombres = "&nombres_ec=";
  let direcciones = "&direcciones_ec=";
  let codigos_postales = "&codigos_postales_ec=";
  let poblaciones = "&poblaciones_ec=";
  let telefonos = "&telefonos_ec=";

  inputList.forEach((element, index) => {
    nombres += element.contactData.nombre.trimEnd();
    direcciones += element.contactData.direccion.trimEnd();
    codigos_postales += element.contactData.codigoPostal.trimEnd();
    poblaciones += element.contactData.poblacion.trimEnd();
    telefonos += element.contactData.telefono.trimEnd();

    if (index !== inputList.length - 1) {
      nombres += ";";
      direcciones += ";";
      codigos_postales += ";";
      poblaciones += ";";
      telefonos += ";";
    }
  });

  return `${nombres}${direcciones}${codigos_postales}${poblaciones}${telefonos}`;
};

function concatWithCommas(word, times) {
  var concatenated = new Array(times).fill(word);
  var result = concatenated.join(",");
  return result;
}

export const getExtraPracticeCodes = (extras) => {
  const extrasCodes = {
    CM: 4213,
    EE: 4189,
    EC: 6956,
  };

  const result = Object.entries(extrasCodes)
    .filter(([code]) => extras.some((extra) => extra.id === code))
    .map(([code, value]) =>
      concatWithCommas(
        value,
        extras.find((extra) => extra.id === code).courseQuantity
      )
    )
    .join(",");

  return result;
};

export const getInputNameList = (attrName, inputList, personsNumber) => {
  let result = "";
  if (
    inputList.length != personsNumber &&
    (personsNumber != 1 || inputList.length != 1)
  ) {
    result += `&${attrName}=`;
    inputList.forEach((element) => {
      result += `${element};`;
    });
  }
  return result.slice(0, -1);
};
